module.exports = __webpack_public_path__ + "static/screenshot-editor-1fa7f845bc0c9ed177d2c98a7339f2f6.jpg";